import React from "react";

import { Component } from "../../../../commons/types/component";
import { IconSource } from "../../../../commons/types/icon";
import { IconSmallAngleDown, IconSmallAngleUp } from "../../../../resources/icons";
import cn from "../../libs/class-name";
import Dot from "../Dot/Dot";
import Icon from "../Icon/Icon";

interface Props extends Component {
  active?: boolean;
  children: React.ReactNode;
  icon: IconSource;
  label: string;
  onToggle: () => void;
  open: boolean;
}

const ProductFilterListGroup = ({ active = false, classNames = [], children, icon, label, onToggle, open }: Props) => (
  <section className={cn("ProductFilterListGroup", [{ open }], classNames)}>
    <button aria-expanded={open} className="ProductFilterListGroup__button" onClick={onToggle} type="button">
      <Icon classNames={["ProductFilterListGroup__leading-icon"]} source={icon} />
      <span className="ProductFilterListGroup__label">{label}</span>
      {!open && active && <Dot classNames={["ProductFilterListGroup__indicator"]} />}
      <Icon classNames={["ProductFilterListGroup__icon"]} source={open ? IconSmallAngleUp : IconSmallAngleDown} />
    </button>
    {open && (
      <ul className="ProductFilterListGroup__list">
        {React.Children.map(children, (child, index) => {
          const childKey = React.isValidElement(child) && child.key !== null ? child.key : index;

          return (
            <li className="ProductFilterListGroup__item" key={childKey}>
              {child}
            </li>
          );
        })}
      </ul>
    )}
  </section>
);

export default ProductFilterListGroup;
